import React from 'react'
import Sidebar from "../components/Sidebar"

const Setting = () => {
    return (
       <> 
       <Sidebar/>
        <div className='setting'>
          Setting
        </div>
      </>
    )
}

export default Setting